export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-comment-quotes-986227f7c4b0ae542b0c6f4703d5f8e0.svg";